export async function glossary() {
    const filters = document.querySelectorAll(".glossary-filters .filter .filter-range");
    const mobileFilterMenu = document.querySelector(".oportun-glossary .oportun-accordion span.title");
    const termGroups = document.querySelectorAll(".oportun-glossary .glossary-terms");
    let currentTerm = 1;

    filters.forEach((filter) => {
        filter.addEventListener("click", showTerms);
    });

    function showTerms(e){
        const selectedFilter = e.target;
        const selectedTerm = selectedFilter.dataset.index;
        if(selectedTerm != currentTerm){
            currentTerm = selectedTerm
            filters.forEach((filter) => {
                if(filter.dataset.index == currentTerm){
                    filter.parentNode.classList.add("active");
                }else{
                    filter.parentNode.classList.remove("active");
                }
            });
            selectedFilter.parentNode.classList.add("active");
            termGroups.forEach((group) => {
                if(group.dataset.index != selectedTerm){
                    group.classList.remove("show");
                    group.classList.add("hide");
                }else{
                    group.classList.add("show");
                    group.classList.remove("hide");
                }
            });

            mobileFilterMenu.classList.remove("expanded");
            mobileFilterMenu.nextElementSibling.style.maxHeight = "0px";
        }
    }
}